module.exports = __webpack_public_path__ + "kudos_70.svg?9f8603b478ac1dabbc97417d3dde5edf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_70.svg
// module id = 173
// module chunks = 0